import { useIntl as reactUseIntl } from 'react-intl';
import { useExtendedFormatMessage } from './hooks';
/**
 * Custom `useIntl` hook that extends the functionality of react-intl `useIntl` hook.
 * This hook includes a `formatMessage` method that provides a default message
 * based on the message id when a translation is missing.
 *
 * @returns {Intl} - An object containing the extended `IntlShape` and the custom `formatMessage` function.
 *
 * @example
 * const { formatMessage } = useIntl();
 * const message = formatMessage({ id: 'some.message.id' });
 */
export const useIntl = () => {
    const intl = reactUseIntl();
    const formatMessage = useExtendedFormatMessage(intl);
    const formatPrice = (price, currency, maximumFractionDigits = 0) => {
        return intl.formatNumber(price, {
            style: 'currency',
            currency,
            maximumFractionDigits,
        });
    };
    return {
        formatMessage,
        formatPrice,
        formatDate: intl.formatDate,
        formatTime: intl.formatTime,
    };
};
//# sourceMappingURL=useIntl.js.map